import type { GetFeaturesInnerParams } from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';

export const getTransferFeatures = ({
  isHO,
  isDP,
  dealCard,
  isOverlay,
  t,
  isLiveSearch,
}: GetFeaturesInnerParams): Feature[] => {
  if (isHO) return [];

  const hasTransfer = dealCard?.product?.rate?.offers?.transfer;

  return [
    ...(isLiveSearch && isDP && !isOverlay
      ? [
          ...(hasTransfer
            ? [
                {
                  icon: { category: 'Transportation', name: 'icon-bus', color: 'iconPrimary' } as const,
                  text: t('vacation.oss.cards.flights.transfer_included'),
                  featureType: FeatureType.normal,
                },
              ]
            : []),
        ]
      : []),
  ];
};
